import React, { useState, useEffect } from "react"
import { useHistory } from "react-router-dom"
import { apiClient } from "../../../api"
import CardNormal from "../PackageListSale/CardPackage/CardNormal"
import CardRecommend from "../PackageListSale/CardPackage/CardRecommend"
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react.js'
import 'swiper/swiper-bundle.min.css'
import { Navigation, Pagination, Mousewheel } from "swiper"


export default function PackageListSale() {
  let history = useHistory()

  useEffect(() => {
    fetchData()
  }, [])

  const [data, setData] = useState([])

  const onClickToPage = (id) => {
    const encodedData = btoa(id) // encode a string
    history.push("login?pid=" + encodedData)
  }

  const fetchData = async () => {
    let req = null

    apiClient.post("api/ecom/getPackageSale", {}, {
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
    })
      .then((response) => {
        setData(response.data.PackageList)
      })
      .catch((error) => { })
  }

  return (
    <div className="app" style={{ minHeight: 0 }}>
      <div className="package">
        <div>
          <p
            style={{
              textAlign: "center",
              margin: "20px 0px",
              fontSize: "3rem",
              fontWeight: "bold",
            }}
          >
            How many SMS do you plan to send?
          </p>
        </div>
        <div
          style={{
            padding: "10px",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
          }}
          className={`swiper-wrapper-custom ${data && data.length ? "swiper-wrapper-custom-" + data.length : ""}`}
        >
          {data && data.length > 0 ? (<Swiper
            spaceBetween={25}
            navigation={true}
            mousewheel={true}
            pagination={false}
            grabCursor={true}
            slidesPerView={1}
            breakpoints={{
              640: {
                slidesPerView: data && data.length >= 2 ? 2 : data.length,
              },
              768: {
                slidesPerView: data && data.length >= 2 ? 2 : data.length,
              },
              1024: {
                slidesPerView: data && data.length >= 2 ? 2 : data.length,
              },
              1366: {
                slidesPerView: data && data.length >= 3 ? 3 : data.length,
              },
              1920: {
                slidesPerView: data && data.length >= 5 ? 5 : data.length,
              },
            }}
            modules={[Navigation, Pagination, Mousewheel]}
            className="mySwiper"
          >
            {data.map((obj, index) => {
              if (obj.PackageType === 1 && obj.Package_Recommend) {
                return <SwiperSlide key={`Package${index}`}><CardRecommend key={index + 1} obj={obj} onClickToPage={onClickToPage} /></SwiperSlide>
              } else if (obj.PackageType === 1 && !obj.Package_Recommend) {
                return <SwiperSlide key={`Package${index}`}><CardNormal key={index + 1} obj={obj} onClickToPage={onClickToPage} /></SwiperSlide>
              }
            })}
          </Swiper>) : <div> Not found package  </div>}

        </div>
      </div>
    </div>
  )
}
